import { ResultOf } from 'gql.tada';

import { graphql } from '../../graphqlTypes/graphql';

export const getOnBoardingDetailsReplayQuery = graphql(`
  query professionalOnboardingDetails {
    professionalOnboardingDetails {
      industry
      projectId
      replay {
        uid
        replayId
        shareLink
      }
    }
  }
`);

export type GetOnBoardingReplayQueryResponse = ResultOf<typeof getOnBoardingDetailsReplayQuery>;

export const getProjectReplaysQuery = graphql(`
  query getProjectReplays($projectUID: String!) {
    getProjectReplays(projectUID: $projectUID) {
      uid
      name
      description
      replayId
      projectUID
      createdAt
      createdBy
      sharedUserUID
      fabricUID
      pipelineName
      appNames
      replayJson
      shareLink
    }
  }
`);

export type GetProjectReplayQueryResponse = ResultOf<typeof getProjectReplaysQuery>;
